<template>
  <Dialog class="ts-dialog" v-bind="$attrs" v-on="$listeners" :class="{ 'no-header': noHeader }">
    <template #title>
      <slot name="title"></slot>
    </template>
    <template #footer>
      <slot name="footer"></slot>
    </template>
    <slot></slot>
  </Dialog>
</template>

<style lang="scss" scoped>
.ts-dialog::v-deep {
  &.no-header {
    .el-dialog__header {
      padding: 0;
    }
  }

  .el-dialog {
    background: #ebecf0;
    background-image: linear-gradient(311deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
    background-blend-mode: soft-light, normal;
    background-clip: padding-box;
    border: 2px solid rgba(255, 255, 255, 0.16);
    border-radius: 32px;

    .el-dialog__title {
      font-family: Roboto;
      font-size: 16px;
      font-weight: 500;
      color: #6d7587;
    }

    .el-dialog__body {
      font-family: Roboto;
      font-size: 12px;
      color: #6d7587;
    }
  }
}
</style>

<script>
import { Dialog } from 'element-ui';

export default {
  name: 'TsDialog',
  components: {
    Dialog
  },
  props: {
    noHeader: {
      type: Boolean,
      default: false
    }
  }
};
</script>
